export enum Line {
  PremiumCare = 'Premium Care',
  Pants = 'Pants',
  ConfortSec = 'Confort Sec',
  Supersec = 'Supersec',
  Accessories = 'Acessórios',
  TriplaProtecao = 'Tripla Proteção',
  SupremeCare = 'Supreme Care',
  NaturalCare = 'Natural Care',
  Ultrasec = 'Ultrasec',
  BabysecPremium = 'Babysec Premium',
  MamyPokoDiaNoite = 'MamyPoko Dia & Noite',
  MamyPokoPremium = 'MamyPoko Premium Seca',
  MamyPokoFraldaCalca = 'MamyPoko Fralda-Calça'
}

export type ProductLine = Line | string;

export interface Product {
  id: string | number;
  brand: string; // Novo campo para suportar multimarca
  name: string;
  line: Line | string;
  quantity?: string;
  units?: number;
  link?: string;
  affiliateUrl?: string;
  image?: string;
  imageUrl?: string;
  description?: string;
  shortDescription?: string;
  fullDescription?: string;
  category?: string;
  size?: string;
  keyFeatures?: string[];
  seoKeywords?: string[];
  notesForDev?: string;
  pageUrl?: string;
}

export interface BlogPost {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  date: string;
  readTime: string;
  content: string;
  imageUrl: string;
}